<p-dialog header="{{moduleName}} Settings" (onHide)="cancelSettings()" [(visible)]="displayColumnSettings"
  [style]="{width: '550px', minHeight: '80vh'}" [modal]="true" [baseZIndex]="10000">
  <div class="p-grid" style="height: 100%">
      <div class="p-col-12 p-lg-4 sidemenu">
          <div class="card">
              <ul>
                  <li *ngIf="moduleId !== contactModuleId"
                      (click)="showDiv.stepsbar = true;showDiv.views = false;showDiv.collists = false;showDiv.details = false;showDiv.config = false;showDiv.kanban = false">
                      <a (click)="onClickSideMenu(1)" [ngClass]="{'active': tab==='tab1'}">Display Steps Bar</a>
                  </li>
                  <li *ngIf="moduleId !== contactModuleId"
                      (click)="showDiv.views = true;showDiv.stepsbar = false;showDiv.collists = false;showDiv.details = false;showDiv.kanban = false;showDiv.config = false;">
                      <a (click)="onClickSideMenu(2)" [ngClass]="{'active': tab==='tab2'}">Default View</a>
                  </li>
                  <li
                      (click)="showDiv.collists = true;showDiv.stepsbar = false;showDiv.views = false;showDiv.details = false;showDiv.kanban = false;showDiv.config = false;">
                      <a (click)="onClickSideMenu(3)" [ngClass]="{'active': tab==='tab3'}">List View Columns</a>
                  </li>
                  <li *ngIf="moduleId !== workspaceModuleId"
                      (click)="showDiv.details = true;showDiv.stepsbar = false;showDiv.views = false;showDiv.collists = false;showDiv.kanban = false;showDiv.config = false;">
                      <a (click)="onClickSideMenu(4)" [ngClass]="{'active': tab==='tab4'}">Details View Block</a>
                  </li>
                  <li *ngIf="tempKanbanDetailCols && tempKanbanDetailCols.length>0"
                      (click)="showDiv.kanban = true;showDiv.details = false;showDiv.stepsbar = false;showDiv.views = false;showDiv.collists = false;showDiv.config = false;">
                      <a (click)="onClickSideMenu(5)" [ngClass]="{'active': tab==='tab5'}">Kanban View Data</a>
                  </li>
                  <li *ngIf="moduleId !== workspaceModuleId">
                      <a (click)="resetSettings()">Reset Settings</a>
                  </li>
              </ul>
          </div>
      </div>
      <div class="p-col-12 p-lg-8">
        <div class="card">
            <div *ngIf="showDiv.stepsbar">
                <div class="colList">
                    <p-checkbox
                        [(ngModel)]="tempDisplayStepBar" 
                        binary="true"
                        inputId="binary"
                        [disabled]="moduleId === workspaceModuleId && !selectedWorkbookColumn"
                        (onChange)="detectDisplayStepBarChange($event)">
                    </p-checkbox>
                    {{tempDisplayStepBar
                    ? 'On' : 'Off'}}
                </div>
                <small class="p-error" *ngIf="moduleId === workspaceModuleId && !selectedWorkbookColumn && tempDisplayStepBar && workbookColumns.length > 0">
                    Please select a workbook column first
                </small>
                    <small class="p-error" *ngIf="moduleId === workspaceModuleId && workbookColumns.length === 0 && tempDisplayStepBar">
                    No columns available for step bar
                    </small> 
                <div class="colList" *ngIf="moduleId === workspaceModuleId && workbookColumns.length > 0">
                    <div class="p-d-flex p-ai-center">
                        <label for="workbookColumn" class="p-mb-2 block"><strong>Select Workbook Column</strong></label>
                        <i class="pi pi-info-circle p-ml-2" 
                           pTooltip="• Used to create stages in the step bar&#10;• Choose a column representing workbook stages"
                           tooltipPosition="top">
                        </i>
                    </div>
                    <p-dropdown 
                        id="workbookColumn"
                        [options]="workbookColumns"
                        [(ngModel)]="selectedWorkbookColumn"
                        placeholder="Select Workbook Column"
                        optionLabel="name"
                        optionValue="id"
                        appendTo="body"
                        (onChange)="detectWorkbookColumnChange($event)"
                    >
                    </p-dropdown>
                </div>
            </div>
            <div *ngIf="showDiv.views">
                <div class="colList">
                    <p-dropdown
                        [options]="availableDefaultView"
                        [(ngModel)]="tempView"
                        optionLabel="name"
                        (onChange)="detectDefaultViewChange($event)">
                    </p-dropdown>
                </div>
            </div>
            <div *ngIf="showDiv.collists">
                <div class="p-d-flex">
                    <div>
                        <h6>List View Column Selection (Suggested {{maxAmountForList}}/{{totalAmtForList}})</h6>
                    </div>
                </div>
                <div class="">
                    <div>
                        <input type="text" class="inputStyle p-inputtext" pInputText placeholder="Search for fields"
                            [(ngModel)]="listSearchInput">
                    </div>
                     <div class="p-d-flex p-ai-center gap-1 p-mt-2 ml-custom">
                        <p-checkbox 
                                binary="true"
                                inputId="binary"
                                class="p-mr-2"
                                [(ngModel)]="isSelectAllSectionField"
                                (onChange)="enableAllSectionFields($event,tempCols,'listView')">
                        </p-checkbox>
                        <label for="binary"><strong>Select All Fields</strong></label>
                    </div>
                    <div cdkDropList [cdkDropListData]="tempCols" (cdkDropListDropped)="dropListSection($event, 'listViewSection')" appAutoScroll>
                        <ng-container *ngFor="let section of tempCols; let idx = index">
                            <div *ngIf="(section.fields | gblFilter: listSearchInput: 'name':'childFields')?.length>0" class="colList" cdkDrag (cdkDragStarted)="cdkDragStarted()"
                                (cdkDragReleased)="cdkDragReleased()">
                                <hr style="margin: 0;">
                                <div class="section-header">
                                    <h6 class="sectionLabel">
                                        <span (click)="toggleSection(section); $event.stopPropagation()">
                                            <i class="pi p-mr-3"
                                               [ngClass]="{'pi-minus': (!section?.isToogle || listSearchInput),
                                                          'pi-plus': !(!section?.isToogle || listSearchInput)}">
                                            </i>
                                        </span>
                                        <!-- Move checkbox outside the toggle click area -->
                                        <span (click)="$event.stopPropagation()">
                                            <p-checkbox type="checkbox"
                                                        binary="true"
                                                        inputId="binary"
                                                        class="p-mr-1"
                                                        [disabled]="isSelectAllSectionField"
                                                        (onChange)="enableSectionFields($event,section,'listView',idx)">
                                            </p-checkbox>
                                        </span>
                                        <span (click)="toggleSection(section); $event.stopPropagation()">
                                            {{section.name}}
                                        </span>
                                    </h6>
                                </div>
                                <div *cdkDragPreview>
                                    <h6 class="sectionLabel p-pl-3" style="min-width: 200px;">{{section.name}}</h6>
                                </div>
                                <div *ngIf="(!section?.isToogle && showContent) || (listSearchInput && showContent)" class="sub-columns" cdkDropList
                                    [cdkDropListData]="section.fields" (cdkDropListDropped)="dropCol($event, 'listView', idx)" appAutoScroll>
                                    <ng-container
                                        *ngFor="let col of section.fields | gblFilter: listSearchInput: 'name':'childFields' ; let i = index">
                                        <div class="colList" cdkDrag
                                            [cdkDragDisabled]="!col.dragable"
                                            appendTo="body" *ngIf="col.name">
                                            <div class="p-d-flex">
                                                <i class="fa fa-bars p-mt-1"
                                                    *ngIf="col.dragable"
                                                    style="margin-right: 10px; color:lightgray"></i>
                                                <i class="fa fa-minus p-mt-1"
                                                    *ngIf="!col.dragable"
                                                    style="margin-right: 10px; color:lightgray"></i>
                                                <p-checkbox [(ngModel)]="col.enabled"
                                                    *ngIf="col?.childFields?.length === 0"
                                                    type="checkbox" binary="true" inputId="binary"
                                                    [disabled]="((!col.enabled && maxCheckedFieldForList) || (col?.columnName == 'businessName') || (col.enabled && col?.columnName == 'sequenceNumber' && mergeAccountSequenceNumber && moduleId == 2) || (moduleId == 3 && col?.columnName == 'name') || (moduleId == 8 && ['associationName', 'sequenceNumber'].includes(col?.columnName) && col.enabled) || (disabledLabelNames.includes(col.columnName) && col.enabled))"
                                                    (onChange)="checkUncheckField($event.checked, col, 'listView', idx, 'parent')" class="p-mr-2">
                                                </p-checkbox>
                                                <span class="p-mt-1">{{col.name}}</span>
                                                <button type="button" pButton pRipple
                                                    class="p-button-text p-button-rounded p-button-plain p-ml-2"
                                                    [icon]="col.showChildrens ? 'pi pi-minus' : 'pi pi-plus'"
                                                    *ngIf="col.childFields.length > 0"
                                                    (click)="showChild(col)"
                                                    style="height: 20px; width: 20px;"></button>
                                            </div>
                                            <div
                                                *ngIf="col.childFields.length > 0 && (col.showChildrens || (listSearchInput && (col.childFields | gblFilter: listSearchInput:'name':'childFields')?.length>0))">
                                                <ul>
                                                    <li *ngFor="let childCol of col.childFields">
                                                        <p-checkbox [(ngModel)]="childCol.enabled" type="checkbox"
                                                            binary="true" inputId="binary"
                                                            [disabled]="((!childCol.enabled && maxCheckedFieldForList) || (childCol.isRequired && childCol.enabled) || (disabledLabelNames.includes(childCol.columnName) && childCol.enabled))"
                                                            (onChange)="checkUncheckField($event.checked, childCol, 'listView', idx, 'child', i)"
                                                            class="p-mr-2"></p-checkbox>
                                                        {{childCol.name}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                        </ng-container>
                    </div>

                </div>
            </div>
            <div *ngIf="showDiv.details">
                <div class="p-d-flex">
                    <div>
                        <h6>
                        Details View Column Selection (Suggested {{maxAmountForDetails}}/{{totalAmtForDetails}})</h6>
                    </div>
                </div>
                <div class="">
                    <div>
                        <input type="text" class="inputStyle p-inputtext" pInputText placeholder="Search for fields"
                            [(ngModel)]="detailListSearchInput">
                    </div>
                    <div class="p-d-flex p-ai-center gap-1 p-mt-2 ml-custom">
                        <p-checkbox 
                                binary="true"
                                inputId="binary"
                                class="p-mr-2"
                                [(ngModel)]="isSelectAllSectionField"
                                (onChange)="enableAllSectionFields($event,tempDetailBlocks,'detailsView')">
                        </p-checkbox>
                        <label for="binary"><strong>Select All Fields</strong></label>
                    </div>
                    <div cdkDropList [cdkDropListData]="tempDetailBlocks" (cdkDropListDropped)="dropListSection($event, 'detailsViewSection')" appAutoScroll>
                        <ng-container *ngFor="let section of tempDetailBlocks; let idx = index">
                            <div *ngIf="(section.fields | gblFilter: detailListSearchInput: 'name':'childFields')?.length>0" class="colList" cdkDrag (cdkDragStarted)="cdkDragStarted()"
                                (cdkDragReleased)="cdkDragReleased()">
                                <hr style="margin: 0;">
                                <div class="section-header">
                                    <h6 class="sectionLabel">
                                        <span (click)="toggleSection(section); $event.stopPropagation()">
                                            <i class="pi p-mr-3"
                                               [ngClass]="{'pi-minus': (!section?.isToogle || detailListSearchInput),
                                                          'pi-plus': !(!section?.isToogle || detailListSearchInput)}">
                                            </i>
                                        </span>
                                        <!-- Move checkbox outside the toggle click area -->
                                        <span (click)="$event.stopPropagation()">
                                            <p-checkbox type="checkbox"
                                                        binary="true"
                                                        inputId="binary"
                                                        class="p-mr-1"
                                                        [disabled]="isSelectAllSectionField"
                                                        (onChange)="enableSectionFields($event,section,'detailsView',idx)">
                                            </p-checkbox>
                                        </span>
                                        <span (click)="toggleSection(section); $event.stopPropagation()">
                                            {{section.name}}
                                        </span>
                                    </h6>
                                </div>
                                <div *cdkDragPreview>
                                    <h6 class="sectionLabel p-pl-3" style="min-width: 200px;">{{section.name}}</h6>
                                </div>
                                <div *ngIf="(!section?.isToogle && showContent) || (detailListSearchInput && showContent)" class="sub-columns" cdkDropList
                                    [cdkDropListData]="section.fields" (cdkDropListDropped)="dropCol($event, 'detailsView', idx)" appAutoScroll>
                                    <ng-container
                                        *ngFor="let col of section.fields | gblFilter: detailListSearchInput: 'name':'childFields' ; let i = index">
                                        <div class="colList" cdkDrag
                                            [cdkDragDisabled]="!col.dragable"
                                            appendTo="body" *ngIf="col.name">
                                            <div class="p-d-flex">
                                                <i class="fa fa-bars p-mt-1"
                                                    *ngIf="col.dragable"
                                                    style="margin-right: 10px; color:lightgray"></i>
                                                <i class="fa fa-minus p-mt-1"
                                                    *ngIf="!col.dragable"
                                                    style="margin-right: 10px; color:lightgray"></i>
                                                <p-checkbox [(ngModel)]="col.enabled"
                                                    *ngIf="col?.childFields?.length === 0"
                                                    type="checkbox" binary="true" inputId="binary"
                                                    [disabled]="((!col.enabled && maxCheckedFieldForDetails) || (col?.columnName == 'businessName')  || (col.enabled && col?.columnName == 'sequenceNumber' && mergeAccountSequenceNumber && moduleId == 2) || (moduleId == 3 && col?.columnName == 'name') || (moduleId == 8 && ['associationName', 'sequenceNumber'].includes(field?.columnName) && col.enabled))"
                                                    (onChange)="checkUncheckField($event.checked, col, 'detailsView', idx, 'parent')" class="p-mr-2">
                                                </p-checkbox>
                                                <span class="p-mt-1">{{col.name}}</span>
                                                <button type="button" pButton pRipple
                                                    class="p-button-text p-button-rounded p-button-plain p-ml-2"
                                                    [icon]="col.showChildrens ? 'pi pi-minus' : 'pi pi-plus'"
                                                    *ngIf="col.childFields.length > 0"
                                                    (click)="showChild(col)"
                                                    style="height: 20px; width: 20px;"></button>
                                            </div>
                                            <div *ngIf="col.childFields.length > 0 && (col.showChildrens || (detailListSearchInput && (col.childFields | gblFilter: detailListSearchInput:'name':'childFields')?.length>0))">
                                                <ul>
                                                    <li *ngFor="let childCol of col.childFields">
                                                        <p-checkbox [(ngModel)]="childCol.enabled" type="checkbox"
                                                            binary="true" inputId="binary"
                                                            [disabled]="((!childCol.enabled && maxCheckedFieldForDetails) || (col.isRequired && col.enabled))"
                                                            (onChange)="checkUncheckField($event.checked, childCol, 'detailsView', idx, 'child', i)"
                                                            class="p-mr-2"></p-checkbox>
                                                        {{childCol.name}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                        </ng-container>
                    </div>

                </div>
            </div>
            <div *ngIf="showDiv.kanban">
                <div class="p-d-flex">
                    <div>
                        <h6>Kanban View Column Selection (Suggested {{maxAmountForKanban}}/{{totalAmtForKanban}})</h6>
                    </div>
                </div>
                <div class="">
                    <div>
                        <input type="text" class="inputStyle p-inputtext" pInputText placeholder="Search for fields"
                            [(ngModel)]="detailListSearchInput">
                    </div>
                    <div class="p-d-flex p-ai-center gap-1 p-mt-2 ml-custom">
                        <p-checkbox 
                                binary="true"
                                inputId="binary"
                                class="p-mr-2"
                                [(ngModel)]="isSelectAllSectionField"
                                (onChange)="enableAllSectionFields($event,tempKanbanDetailCols,'kanbanView')">
                        </p-checkbox>
                        <label for="binary"><strong>Select All Fields</strong></label>
                    </div>
                    <div cdkDropList [cdkDropListData]="tempKanbanDetailCols" (cdkDropListDropped)="dropListSection($event, 'kanbanViewSection')" appAutoScroll>
                        <ng-container *ngFor="let section of tempKanbanDetailCols; let idx = index">
                            <div *ngIf="(section.fields | gblFilter: detailListSearchInput: 'name':'childFields')?.length>0" class="colList" cdkDrag (cdkDragStarted)="cdkDragStarted()"
                                (cdkDragReleased)="cdkDragReleased()">
                                <hr style="margin: 0;">
                                <div class="section-header">
                                    <h6 class="sectionLabel">
                                        <span (click)="toggleSection(section); $event.stopPropagation()">
                                            <i class="pi p-mr-3"
                                               [ngClass]="{'pi-minus': (!section?.isToogle),
                                                          'pi-plus': !(!section?.isToogle)}">
                                            </i>
                                        </span>
                                        <!-- Move checkbox outside the toggle click area -->
                                        <span (click)="$event.stopPropagation()">
                                            <p-checkbox type="checkbox"
                                                        binary="true"
                                                        inputId="binary"
                                                        class="p-mr-1"
                                                        [disabled]="isSelectAllSectionField"
                                                        (onChange)="enableSectionFields($event,section,'kanbanView',idx)">
                                            </p-checkbox>
                                        </span>
                                        <span (click)="toggleSection(section); $event.stopPropagation()">
                                            {{section.name}}
                                        </span>
                                    </h6>
                                </div>
                                <div *cdkDragPreview>
                                    <h6 class="sectionLabel p-pl-3" style="min-width: 200px;">{{section.name}}</h6>
                                </div>
                                <div *ngIf="(!section?.isToogle && showContent) || (detailListSearchInput && showContent)" class="sub-columns" cdkDropList
                                    [cdkDropListData]="section.fields" (cdkDropListDropped)="dropCol($event, 'kanbanView', idx)" appAutoScroll>
                                    <ng-container
                                        *ngFor="let col of section.fields | gblFilter: detailListSearchInput: 'name':'childFields' ; let i = index">
                                        <div class="colList" cdkDrag
                                            [cdkDragDisabled]="!col.dragable"
                                            appendTo="body" *ngIf="col.name">
                                            <div class="p-d-flex">
                                                <i class="fa fa-bars p-mt-1"
                                                    *ngIf="col.dragable"
                                                    style="margin-right: 10px; color:lightgray"></i>
                                                <i class="fa fa-minus p-mt-1"
                                                    *ngIf="!col.dragable"
                                                    style="margin-right: 10px; color:lightgray"></i>
                                                <p-checkbox [(ngModel)]="col.enabled"
                                                    *ngIf="col?.childFields?.length === 0"
                                                    type="checkbox" binary="true" inputId="binary"
                                                    [disabled]="((!col.enabled && maxCheckedFieldForKanban) || (col?.columnName == 'businessName') || (moduleId == 3 && col?.columnName == 'name') || (moduleId == 8 && ['associationName', 'sequenceNumber'].includes(field?.columnName) && col.enabled))"
                                                    (onChange)="checkUncheckField($event.checked, col, 'kanbanView', idx, 'parent')" class="p-mr-2">
                                                </p-checkbox>
                                                <span class="p-mt-1">{{col.name}}</span>
                                                <button type="button" pButton pRipple
                                                    class="p-button-text p-button-rounded p-button-plain p-ml-2"
                                                    [icon]="col.showChildrens ? 'pi pi-minus' : 'pi pi-plus'"
                                                    *ngIf="col.childFields.length > 0"
                                                    (click)="showChild(col)"
                                                    style="height: 20px; width: 20px;"></button>
                                            </div>
                                            <div
                                                *ngIf="col.childFields.length > 0 && (col.showChildrens || (detailListSearchInput && (col.childFields | gblFilter: detailListSearchInput:'name':'childFields')?.length>0))">
                                                <ul>
                                                    <li *ngFor="let childCol of col.childFields">
                                                        <p-checkbox [(ngModel)]="childCol.enabled" type="checkbox"
                                                            binary="true" inputId="binary"
                                                            [disabled]="((!childCol.enabled && maxCheckedFieldForKanban) || (col.isRequired && col.enabled))"
                                                            (onChange)="checkUncheckField($event.checked, childCol, 'kanbanView', idx, 'child', i)"
                                                            class="p-mr-2"></p-checkbox>
                                                        {{childCol.name}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                        </ng-container>
                    </div>

                </div>
            </div>
            <div *ngIf="showDiv.config && isUserSignedIn">
                <div class="p-d-flex">
                  <div>
                    <button pButton (click)="app.checkConfigurationAndPerformOps()" label="Sign Out"></button>
                  </div>
                </div>
            </div>
        </div>
      </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button (onClick)="cancelSettings()" label="Cancel" styleClass="p-button-secondary"></p-button>
    <p-button (onClick)="saveColumnSettings()"
    [disabled]="updateColumnSettingsData?.listViewFields?.length < 1 &&
                updateColumnSettingsData?.detailsViewFields?.length < 1 &&
                updateColumnSettingsData?.kanbanViewFields?.length < 1 &&
                updateColumnSettingsData?.listViewSections?.length < 1 &&
                updateColumnSettingsData?.detailsViewSections?.length < 1 &&
                !detectStepBarOrDefaultViewChange" label="Save"></p-button>
  </ng-template>

</p-dialog>
